import { SHIPPER_GUIDE_API_URL } from 'core/infra/environment'
import { HttpClient, createTokenInterceptor } from 'core/infra/http/HttpClient'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AllInOneUserRepository } from './AllInOneUserRepository'

export function createAllInOneHttpClient() {
  const storage = new LocalStorageClient()
  const userRepository = new AllInOneUserRepository({ storage })
  const httpClient = new HttpClient(SHIPPER_GUIDE_API_URL, {
    requestInterceptor: createTokenInterceptor({ userRepository }),
  })

  return httpClient
}
